/**
 * @fileoverview Authentication navigation hook that manages UI state transitions between
 * different authentication forms using Redux dispatch actions.
 *
 * @module useAuthNavigation
 *
 * Custom hook that provides methods to navigate between different authentication UI states.
 *
 * @returns {Object} Navigation methods
 * @returns {Function} returns many functions to change the active authentication module and form
 */

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    setActiveAuthModuleForm,
    setActiveAuthModule,
    authModules,
    authModulesForms,
    openAuthDialog
} from '../../app/store/slices/authDialog';

export default function useAuthNavigation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return {
        showLoginForm: () => {
            dispatch(setActiveAuthModule(authModules.LOGIN));
            dispatch(setActiveAuthModuleForm(authModulesForms.LOGIN_FORM));
        },
        showVerifyEmailForm: () => {
            dispatch(setActiveAuthModule(authModules.REGISTER));
            dispatch(setActiveAuthModuleForm(authModulesForms.VERIFY_EMAIL_FORM));
        },
        showForgotPasswordForm: () => {
            dispatch(setActiveAuthModule(authModules.LOGIN));
            dispatch(setActiveAuthModuleForm(authModulesForms.FORGOT_PASSWORD_FORM));
        },
        showGuestLogin: () => {
            dispatch(setActiveAuthModule(authModules.GUEST));
            dispatch(setActiveAuthModuleForm(authModulesForms.GUEST_LOGIN_FORM));
        },
        backToLoginForm: () => {
            dispatch(setActiveAuthModule(authModules.LOGIN));
            dispatch(setActiveAuthModuleForm(authModulesForms.LOGIN_FORM));
            dispatch(openAuthDialog());
            navigate('/', { replace: true });
        },
        showCompleteProfileForm: () => {
            dispatch(setActiveAuthModule(authModules.REGISTER));
            dispatch(setActiveAuthModuleForm(authModulesForms.COMPLETE_PROFILE_FORM));
            // navigate('/', { replace: true });
        },
        openAuth: () => {
            dispatch(openAuthDialog());
        }
    };
}
